<div class="wrapper wrapper-content ng-scope animated fadeInRight">
  <div class="container-fluid  p-0">
    <ng-container *ngIf="contractList && contractList.length > 0; else noContracts">
      <div class="row m-t-xs">
        <div class="col-12">
          <span class="float-right leyenda">{{contractList.length}} {{'Contracts.counter'|translate}}</span>
        </div>
      </div>
      <ng-container *ngFor="let contract of contractList">
        <div class="row">
          <div class="col-12">
            <p-panel styleClass="mb-3" [toggleable]="true" [collapsed]="
            this.collapsedContracts[contract.division.identifier]==true
            || this.collapsedContracts[contract.division.identifier]==undefined &&
            (
              (divisionId&&contract.division.identifier!=divisionId)
              || (!divisionId&&contractList.length>1)
              )" (onAfterToggle)="loadOneContract($event,contract)">
              <p-header><span><i class="fa fas fa-lg fa-file-contract"></i><strong>
                    {{contract.division.name}}</strong></span>
              </p-header>
              <ng-container *ngTemplateOutlet="contractPanel; context: { contract: contract }">
              </ng-container>
            </p-panel>
          </div>
        </div>
      </ng-container>
    </ng-container>
  </div>
</div>
<!-- TEMPLATE CON LOS DATOS DEL CONTRAT-->
<ng-template #contractPanel let-contract="contract">
  <p-tabView *ngIf="isContractExecutionEnabled ()" (onChange)="handleChange($event, contract)"
    [activeIndex]="this.selectedContractTabs[contract.division.identifier]">
    <p-tabPanel cache="false" header="{{'Contracts.panel.registerData' | translate}}">
      <ng-container *ngTemplateOutlet="contractInfo; context: { contract: contract }">
      </ng-container>
    </p-tabPanel>
    <p-tabPanel cache="false" header="{{'Contracts.panel.contractExecution' | translate}}">
      <ng-container *ngTemplateOutlet="contractExecution; context: { contract: contract }">
      </ng-container>
      <ng-container *ngTemplateOutlet="contractEspecialesEjecucion; context: { contract: contract }">
      </ng-container>
    </p-tabPanel>
    <p-tabPanel cache="false" header="{{'Contracts.panel.kpis' | translate}}"
      *ngIf="kpisRecords && kpisRecords.length>0">
      <ng-container *ngTemplateOutlet="contractKpis; context: { contract: contract }">
      </ng-container>
    </p-tabPanel>
    <p-tabPanel cache="false" *ngIf="contract.continuationDossierTracing && isExecutionMonitoringModuleEnabled()"
      header="{{'Contracts.panel.continuationDossierPlan' | translate}}">
      <ng-container *ngTemplateOutlet="continuationDossierPlan; context: { contract: contract }">
      </ng-container>
    </p-tabPanel>
    <p-tabPanel cache="false" *ngIf="isContractConfigurationEnabled ()"
      header="{{'Contracts.panel.configuration.description' | translate}}">
      <ng-container *ngTemplateOutlet="contractConfiguration; context: { contract: contract }">
      </ng-container>
    </p-tabPanel>
  </p-tabView>
  <ng-container *ngIf="!isContractExecutionEnabled () && !isContractConfigurationEnabled ()">
    <ng-container *ngTemplateOutlet="contractInfo; context: { contract: contract }">
    </ng-container>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA CUANDO NO HAY CONTRATOS -->
<ng-template #noContracts>
  <div class="alert alert-info m-b-xs text-ellipsis col-12" role="alert">
    <span>
      <i aria-hidden="true" class="fas fa-1-5x fa-exclamation-circle m-r-md"></i> {{ 'Contracts.noContracts' | translate
      }}</span>
  </div>
</ng-template>
<!-- TEMPLATE PARA EL CONTENIDO DEL PANEL DEL CONTRATO -->
<ng-template #contractInfo let-contract="contract">
  <ng-container *ngTemplateOutlet="contractBasicInfo; context: { contract: contract }">
  </ng-container>
  <ng-container
    *ngIf="contract.procurementProjectInfo && contract.procurementProjectInfo.apportioned && contract['LOTES'] && contract['LOTES'].length > 0">
    <ng-container *ngTemplateOutlet="contractLots; context: { contract: contract }">
    </ng-container>
  </ng-container>
  <ng-container *ngTemplateOutlet="contractDocs; context: { contract: contract }">
  </ng-container>
  <ng-container *ngIf="contract.registrationNumber && getModificationsFiltered(contract,true).length>0">
    <ng-container *ngIf="activeExtensionBreakdown">
      <ng-container
        *ngTemplateOutlet="contractModifications; context: { contract: contract, onlyExtensions: true, title: 'Contracts.Modifications.titleExtensions' }">
      </ng-container>
    </ng-container>
    <ng-container
      *ngTemplateOutlet="contractModifications; context: { contract: contract, onlyExtensions: false, title: 'Contracts.Modifications.title' }">
    </ng-container>
  </ng-container>
  <ng-container *ngIf="contract.registrationNumber && getModificationsFiltered(contract,true).length==0">
    <ng-container
      *ngTemplateOutlet="contractModifications; context: { contract: contract, onlyExtensions: false, title: 'Contracts.Modifications.title' }">
    </ng-container>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LOS DATOS BASICOS DEL CONTRATO -->
<ng-template #contractBasicInfo let-contract="contract">
  <h2 class="mt-1 mb-3 titleElement">{{'Contracts.titleContractData' | translate}}</h2>
  <div class="row mt-1">
    <div class="col-12 col-md-12" *ngIf="cliente && cliente==='AYMAD'">
      <dl class="row">
        <dt class="col-12 col-md-2">{{'Sistema Inscripción'| translate}}:</dt>
        <dd class="col-12 col-md-10">
          <span>{{contract.isProjectReplyca?'REPLYCA':'RECON'}}</span>
        </dd>
      </dl>
    </div>
    <div class="col-12">
      <dl class="row">
        <dt class="col-12 col-md-4">{{'Contracts.company.name' | translate}}:</dt>
        <dd class="col-12 col-md-8">
          <span
            *ngIf="contract.company && contract.company.extendedDataIdentifier">{{contract.company.extendedDataIdentifier}}
            -</span>
          <span *ngIf="contract.company && contract.company.name">{{contract.company.name}}</span>
          <span *ngIf="contract.company && contract.company.commercialName">({{contract.company.commercialName}})</span>
          <button appNoDblClick aria-expanded="false" class="d-inline-flex btn btn-sm btn-outline-secondary ml-2"
            title="{{'General.view' | translate}}" (click)="openWindowCompany (contract.company)">
            <i aria-hidden="true" class="fa fa-eye"></i>
          </button>
          <button *ngIf="contract['EXT_DATA_RIL_DOSSIER'] && contract['EXT_DATA_RIL_DOSSIER'].identifier" appNoDblClick
            aria-expanded="false" class="d-inline-flex btn btn-sm btn-outline-secondary ml-2"
            title="{{'CompanyList.ril.view' | translate}}" (click)="openRilFile (contract)">
            <i aria-hidden="true" class="fa fa-archive"></i>
          </button>
        </dd>
        <dt *ngIf="getRepresentative(contract)" class="col-12 col-md-4">{{'Contracts.company.representative' |
          translate}}:</dt>
        <dd *ngIf="getRepresentative(contract)" class="col-12 col-md-8">
          {{getRepresentative(contract).name}} {{getRepresentative(contract).surname}}
          {{getRepresentative(contract).lastName}}
        </dd>
        <dt class="col-12 col-md-4">{{'Contracts.registerNum'| translate}} / {{'DocumentState.state' | translate}}:</dt>
        <dd class="col-12 col-md-8">
          <span class="pr-3">{{contract.registrationNumber}}</span>
          <span
            [ngClass]="statusInList(contract.document.currentState.type.identifier,contractApprovedStatuses)?'bg-success':''"
            *ngIf="this.project.status.situation!='Cancelled' && contract.document && contract.document.currentState && contract.document.currentState.type"
            class="badge badge-secondary"> {{contract.document.currentState.type.description}}</span>
          <span
            [ngClass]="statusInList(contract.document.currentState.type.identifier,contractApprovedStatuses)?'bg-success':''"
            *ngIf="this.project.status.situation=='Cancelled'" class="badge badge-danger">
            {{'DossierDetail.situation.canceled' | translate}}</span>
        </dd>
        <dt class="col-12 col-md-4">{{'Contracts.data.endDate'|translate}}:</dt>
        <dd class="col-12 col-md-8">
          <span *ngIf="contract.plannedPeriod"> {{contract.plannedPeriod.startDate | date: 'dd/MM/yyyy'}}</span>
          <span *ngIf="contract.plannedPeriod && contract.plannedPeriod.finalEndDate"> -
            {{contract.plannedPeriod.finalEndDate | date: 'dd/MM/yyyy'}}</span>
        </dd>
        <dt class="col-12 col-md-4"><span
            *ngIf="!cliente || cliente!=='AYMAD' || (cliente==='AYMAD' && contract.isProjectReplyca)">{{'Contracts.data.execitionTerm'|
            translate}}:</span></dt>
        <dd class="col-12 col-md-3">
          <span *ngIf="!cliente || cliente!=='AYMAD' || (cliente==='AYMAD' && contract.isProjectReplyca)">
            <span *ngIf="contract.plannedPeriod&&contract.plannedPeriod.finalExecutionPeriodText">
              <!--/--> {{contract.plannedPeriod.finalExecutionPeriodText}}</span>
          </span>
        </dd>
        <dd class="col-12 col-md-5">
          <span *ngIf="!cliente || cliente!=='AYMAD' || (cliente==='AYMAD' && contract.isProjectReplyca)">
            <p-progressBar [value]="contract.plannedPeriod.expiredPeriod"
              unit="% {{'Contracts.data.termExpired'|translate}}"></p-progressBar>
          </span>
        </dd>
        <dt class="col-12 col-md-4">{{'Contracts.data.initialAmount'|translate}}:</dt>
        <dd class="col-12 col-md-3">
          <span *ngIf="contract.budget && contract.budget.currentAmountExcludingTaxes">
            {{contract.budget.currentAmountExcludingTaxes | currency: 'EUR'}}</span>
        </dd>
        <dd class="col-12 col-md-5">
          <span *ngIf="!cliente || cliente!=='AYMAD' || (cliente==='AYMAD' && contract.isProjectReplyca)">
            <p-progressBar [value]="executionPercent" unit="% {{'Contracts.data.amountExecuted'|translate}}">
            </p-progressBar>
          </span>
        </dd>
        <dt class="col-12 col-md-4">{{'Contracts.data.initialGuarantee'|translate}}:</dt>
        <dd class="col-12 col-md-3">
          <!--<span *ngIf="contract.contractSummary && contract.contractSummary.initialWarrantyReturnDate">
            {{contract.contractSummary.initialWarrantyReturnDate | date: 'dd/MM/yyyy'}} </span>-->
          <span *ngIf="contract.contractSummary && contract.contractSummary.warrantyReturnDate">
            <!-- -<strong>--> {{contract.contractSummary.warrantyReturnDate | date: 'dd/MM/yyyy'}}
            <!--</strong>--></span>
        </dd>
        <dd class="col-12 col-md-5">
          <span *ngIf="!cliente || cliente!=='AYMAD' || (cliente==='AYMAD' && contract.isProjectReplyca)">
            <p-progressBar [value]="guaranteePercent" unit="% {{'Contracts.data.guaranteeTerm'|translate}}">
            </p-progressBar>
          </span>
        </dd>
      </dl>
    </div>
    <!-- LISTADO DE CAMPOS PERSONALIZABLES VISIBLES, CONFIGURADOS DESDE config.json con la variable contractVisibleCustomFields-->
    <div class="col-12">
      <dl class="row">
        <ng-container *ngFor="let customFieldVisible of customFieldConfiguration">
          <ng-container *ngFor="let customField of contract?.customFieldDefinitions | keyvalue">
            <ng-container *ngIf="!isBreak && customFieldVisible.name === customField.key; else breakContainer">
              <dt class="col-12 col-md-4">{{ customField.value.display.i18nDescription }}:</dt>
              <dd class="col-12 col-md-8">
                <formatDataValue [type]="customFieldVisible.format" [value]="contract?.customFields[customField.key] ">
                </formatDataValue>
              </dd>
            </ng-container>
          </ng-container>
        </ng-container>
        <ng-template #breakContainer></ng-template>
      </dl>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE VISUALIZACION DE LOTES DEL CONTRATO -->
<ng-template #contractLots let-contract="contract">
  <h2 class="mb-3 titleElement">{{'Contracts.titleContractLots'|translate}}</h2>
  <div class="lotes">
    <div class="p-table ui-widget p-table-responsive">
      <div class="p-table-wrapper">
        <table style="width: 100%;">
          <thead class="p-table-thead"></thead>
          <tbody class="p-table-tbody">
            <tr *ngFor="let lot of contract.LOTES">
              <td style="width: 75px;">
                <span class="p-column-title">{{'Contracts.lots.title' | translate}}</span> {{'Contracts.lots.title' |
                translate}} {{lot.lot.lotNumber}}
              </td>
              <td>{{lot.lot.description}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE DOCUMENTOS DESTACADOS DEL CONTRATO -->
<ng-template #contractDocs let-contract="contract">
  <ng-container *ngIf="contract['EXT_DATA_DOCUMENTS'] && contract['EXT_DATA_DOCUMENTS'].length > 0">
    <h2 class="mt-3 mb-3 titleElement">{{'Contracts.titleContractDocuments'| translate}}</h2>
    <span class="m-xs" *ngIf="!contract['EXT_DATA_DOCUMENTS_LOADED']" class="leyenda">
      <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.Documents.loading'| translate}} </span>
    <div class="p-table ui-widget" *ngIf="contract['EXT_DATA_DOCUMENTS_LOADED']">
      <div class="p-table-wrapper">
        <table class="w-100">
          <thead class=" p-table-thead">
            <tr>
              <th style="width: 35%;">{{'General.document'|translate}}</th>
              <th style="width: 20%;">{{'General.date.text'| translate}}</th>
              <th style="width: 25%;">{{'DocumentFile.signers' | translate}}</th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody class="p-table-tbody">
            <tr *ngFor="let doc of contract['EXT_DATA_DOCUMENTS']">
              <td>
                <span><i aria-hidden="true" class="far fa-file-alt px-1 fa-1-5x"></i>{{doc.name}}</span>
              </td>
              <td> {{(doc.currentState?doc.currentState.date: doc.date) | date: 'dd/MM/yyyy HH:mm:ss'}} </td>
              <td class="text-left">
                <span> {{getFirmantes(doc)}} </span>
              </td>
              <td class="text-right">
                <div class="btn-group">
                  <button appNoDblClick aria-expanded="false" class="btn btn-sm btn-outline-secondary"
                    title="Visualizar" (click)="viewDocument (doc)">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE INCIDENCIAS DEL CONTRATO -->
<ng-template #contractModifications let-contract="contract" let-onlyExtensions="onlyExtensions" let-title="title">
  <!-- SE MUESTRA SI HAY INCIDENCIAS O SE PUEDEN CREAR -->
  <ng-container *ngIf="
    getModificationsFiltered(contract, onlyExtensions) && getModificationsFiltered(contract, onlyExtensions).length > 0
    || isNewContractModificationVisible ()">
    <h2 class="mt-4 mb-3 titleElement">{{title|translate}}</h2>
    <span class="m-xs" *ngIf=" !contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']" class="leyenda">
      <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.Modifications.loading'| translate}}
    </span>
    <ng-container
      *ngIf="getModificationsFiltered(contract, onlyExtensions) && getModificationsFiltered(contract, onlyExtensions).length > 0">
      <div class="p-table ui-widget" *ngIf="contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']">
        <div class="p-table-wrapper">
          <p-table [value]="getModificationsFiltered(contract, onlyExtensions)" [scrollable]="false"
            responsiveLayout="scroll">
            <ng-template pTemplate="header">
              <tr>
                <th *ngIf="!onlyExtensions" [style.width]="'20%'">{{'General.type'|translate}}</th>
                <th *ngIf="this.viewRegisterNumber" [style.width]="!onlyExtensions? '30%': '40%'">
                  {{'General.description'| translate}}</th>
                <th *ngIf="!this.viewRegisterNumber" [style.width]="!onlyExtensions? '30%': '40%'">
                  {{'General.description'| translate}}</th>
                <th [style.width]="'20%'">{{'DocumentState.state' | translate}}</th>
                <th *ngIf="this.viewRegisterNumber" [style.width]="'15%'"> {{'Contracts.registerNum' | translate}}</th>
                <th *ngIf="this.viewRegisterNumber" [style.width]="'30%'">{{'Sistema Inscripción' | translate}}</th>
                <th *ngIf="!this.viewRegisterNumber" [style.width]="!onlyExtensions? '15%': '25%'">Modificación</th>
                <!--INI CABECERAS DE CAMPOS PERSONALIZABLES DE INCIDENCIAS-->
                <ng-container *ngFor="let customFieldVisible of contractModificationVisibleCustomFields">
                  <th [style.width]="'10%'">{{ customFieldVisible.name_i18n }}</th>
                </ng-container>
                <!--FIN CABECERAS DE CAMPOS PERSONALIZABLES DE INCIDENCIAS-->
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-modif>
              <tr>
                <td *ngIf="!onlyExtensions"><span class="p-column-title">{{'General.type'|translate}}</span>
                  {{modif.name}} </td>
                <td><span class="p-column-title">{{'General.description'| translate}}</span> {{modif.reason}}</td>
                <td class="text-truncate w-100"><span class="p-column-title">{{'DocumentState.state' |
                    translate}}</span>
                  <span *ngIf="modif.document && modif.document.currentState.type.description"
                    [ngClass]="statusInList(modif.document.currentState.type.identifier,contractModificationApprovedStatuses)?'bg-success':''"
                    class="badge badge-secondary"> {{modif.document.currentState.type.description}}</span>
                  <span *ngIf="!modif.document || !modif.document.currentState.type.description"
                    class="badge badge-secondary"> {{'DossierActions.pending' | translate}}</span>
                </td>
                <td *ngIf="this.viewRegisterNumber"><span class="p-column-title">{{'Contracts.registerNum' |
                    translate}}</span>
                  <span *ngIf="modif.registerNumber">{{modif.registerNumber}}</span>
                </td>
                <td *ngIf="this.viewRegisterNumber"> {{modif.isRegisterContractModificationReplyca?'REPLYCA':'RECON'}}
                </td>
                <td *ngIf="!this.viewRegisterNumber"><span class="ui-column-title"></span>
                  <span class="d-block" *ngIf="modif.budget.budgetModification">
                    <i class="fa fas"
                      [ngClass]="modif.budget.amountExcludingTaxes>=0?'fa-plus text-success':'fa-minus text-danger'"></i>
                    {{absoluteValue(modif?.budget?.amountExcludingTaxes) | currency: 'EUR'}} </span>
                  <span class="d-block" *ngIf="modif.plannedPeriod.durationModification">
                    <i class="fa fas"
                      [ngClass]="modif.plannedPeriod.duration>=0?'fa-plus text-success':'fa-minus text-danger'"></i>
                    {{absoluteValue(modif?.plannedPeriod?.duration) | number}}
                    {{'TimeUnit.'+modif?.plannedPeriod?.durationUnit?.identifier | translate}} </span>
                  <span *ngIf="onlyExtensions && modif.plannedPeriod && modif.plannedPeriod.auxDate">
                    <i class="fa fas fa-calendar"></i> {{absoluteValue(modif?.plannedPeriod?.auxDate) | date:
                    'dd/MM/yyyy'}} </span>
                </td>
                <!-- INI VALORES DE CAMPOS PERSONALIZABLES DE INCIDENCIAS-->
                <ng-container *ngFor="let customFieldVisible of contractModificationVisibleCustomFields">
                  <ng-container *ngFor="let customField of modif?.customFieldDefinitions | keyvalue">
                    <ng-container *ngIf="customFieldVisible.name === customField.key; else breakContainer">
                      <td>
                        <formatDataValue [type]="customFieldVisible.format"
                          [value]="modif?.customFields[customField.key]">
                        </formatDataValue>
                      </td>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!modif?.customFieldDefinitions[customFieldVisible.name]">
                    <td></td>
                  </ng-container>
                </ng-container>
                <ng-template #breakContainer></ng-template>
                <!-- FIN VALORES DE CAMPOS PERSONALIZABLES DE INCIDENCIAS-->
                <td *ngIf="!cliente || cliente!=='AYMAD'" class="text-right">
                  <div class="btn-group">
                    <div *ngIf="isContractModificationEditable(modif) || !modif.document ; else elseBlock">
                      <button *ngIf="isLastEditableModifByType(contract, modif)" appNoDblClick
                        (click)="newContractModification (contract, modif)" class="btn btn-sm btn-outline-secondary">
                        <span><i aria-hidden="true" class="fas fa-pencil-alt"></i></span>
                      </button>
                    </div>
                    <ng-template #elseBlock>
                      <button class="btn  btn-primary btn-sm t-action-button"
                        [routerLink]="['/documentViewer', modif.document.identifier]"
                        title="{{ 'General.visualize' | translate}}">
                        <i class="fas fa-search" aria-hidden="true"></i>
                      </button>
                    </ng-template>
                  </div>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="isNewContractModificationVisible() && !onlyExtensions">
      <ng-container *ngTemplateOutlet="newContractModifications; context: { contract: contract }"></ng-container>
    </ng-container>
    <ng-template #newContractModifications let-contract="contract">
      <div class="mt-2 col-12 pt-0 pb-2 mb-2" *ngIf="contract['EXT_DATA_CONTRACTMODIFICATIONS_LOADED']">
        <button appNoDblClick (click)="newContractModification (contract)"
          class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element"
          [disabled]="!contractModificationsAvailable(contract)">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i>{{'ContractModification.new'|translate}}</span>
        </button>
      </div>
    </ng-template>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE CARPETAS DE FASE DE EJECUCION -->
<ng-template #contractExecution let-contract="contract">
  <div *ngIf="isExecutionMonitoringModuleEnabled()" class="p-h-xs"> {{ 'Contracts.continuationDossierPlan.activation' |
    translate }} <p-inputSwitch onLabel="Activado" offLabel="Desactivado"
      (onChange)="updatecontinuationDossierTracing(contract)" [(ngModel)]="contract.continuationDossierTracing"
      class="btn">
    </p-inputSwitch>
  </div>
  <h2 class="mt-3 mb-3 titleElement">{{'Contracts.ExecutionPhases.title'|translate}}</h2>
  <span class="m-xs" class="leyenda" *ngIf="!contract['EXT_DATA_EXECUTIONPHASES_LOADED']">
    <i class="fa fa-spinner loading-spin" aria-hidden="true"></i> {{'Contracts.ExecutionPhases.loading'| translate}}
  </span>
  <ng-container
    *ngIf="contract['EXT_DATA_EXECUTIONPHASES_LOADED']===true&&contract['EXT_DATA_EXECUTIONPHASES'] && contract['EXT_DATA_EXECUTIONPHASES'].length > 0">
    <div class="p-table ui-widget">
      <div class="p-table-wrapper">
        <table style="width: 100%;">
          <thead class="p-table-thead">
            <tr>
              <th class="col-icon"></th>
              <th style="width: 40%;">{{'Contracts.ExecutionPhases.phase'|translate}}</th>
              <th style="width: 20%;">{{'Documents.creationDate'|translate}}</th>
              <th style="width: 10%;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_FACTURADO')"
                class="text-right"> {{'Contracts.ExecutionPhases.budget.amountInvoiced'|translate}}</th>
              <th style="width: 10%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_FACTURADO')"
                class="text-right">
              </th>
              <th style="width: 10%;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_RECONOCIDO')"
                class="text-right"> {{'Contracts.ExecutionPhases.budget.amountamountRecognised'|translate}}</th>
              <th style="width: 10%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_IMPORTE_RECONOCIDO')"
                class="text-right">
              </th>
              <th style="width: 20;" *ngIf="isDefinedInDivisions(contract, 'DIV_EJEC_FECHA_VENCIM')" class="text-right">
                {{'Contracts.ExecutionPhases.dueDate'|translate}}</th>
              <th style="width: 20%;" *ngIf="!isDefinedInDivisions(contract, 'DIV_EJEC_FECHA_VENCIM')"
                class="text-right">
              </th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody *ngFor="let executionPhase of contract['EXT_DATA_EXECUTIONPHASES']" class="p-table-tbody">
            <tr>
              <td>
                <span>
                  <i *ngIf="isExecutionPhaseClosed(executionPhase)" aria-hidden="true" class="fas fa-folder fa-lg"></i>
                  <i *ngIf="!isExecutionPhaseClosed(executionPhase)" aria-hidden="true"
                    class="far fa-folder-open fa-lg"></i>
                </span>
              </td>
              <td class="text-truncate">
                <span style="line-height: 2em;">{{executionPhase.name}}</span>
              </td>
              <td class="text-truncate">
                <span style="line-height: 2em;">{{executionPhase.creationDate | date:'dd/MM/yyyy'}}</span>
              </td>
              <!--
              <td class="text-center">
                {{executionPhase.creationDate | date: 'dd/MM/yyyy'}}
              </td>
              <td class="text-left">{{executionPhase.phase.description}}</td>
              -->
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_IMPORTE_FACTURADO')" class="text-right">
                {{executionPhase.customFields.DIV_EJEC_IMPORTE_FACTURADO | currency: 'EUR'}}</td>
              <td
                *ngIf="!executionPhase.customFields || executionPhase.customFields.DIV_EJEC_IMPORTE_FACTURADO === undefined"
                class="text-right"></td>
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_IMPORTE_RECONOCIDO')" class="text-right">
                {{executionPhase.customFields.DIV_EJEC_IMPORTE_RECONOCIDO | currency: 'EUR'}}</td>
              <td *ngIf="!isDefined(executionPhase, 'DIV_EJEC_IMPORTE_RECONOCIDO')" class="text-right"></td>
              <td *ngIf="isDefined(executionPhase, 'DIV_EJEC_FECHA_VENCIM')" class="text-right">
                {{executionPhase.customFields.DIV_EJEC_FECHA_VENCIM | date: 'dd/MM/yyyy'}}</td>
              <td *ngIf="!isDefined(executionPhase, 'DIV_EJEC_FECHA_VENCIM')" class="text-right"> </td>
              <td class="text-right">
                <div class="btn-group">
                  <button *ngIf="isExecutionPhaseClosed (executionPhase)" appNoDblClick aria-expanded="false"
                    [disabled]="buttonsDisabled(contract, executionPhase) | async"
                    class="btn btn-sm t-action-button btn-primary" title="Reabrir"
                    (click)="reopenExecutionPhase(contract, executionPhase)">
                    <i aria-hidden="true" class="fa fa-eye"></i>
                  </button>
                  <button *ngIf="!isExecutionPhaseClosed (executionPhase)" appNoDblClick aria-expanded="false"
                    [disabled]="buttonsDisabled(contract, executionPhase) | async"
                    class="btn btn-sm t-action-button btn-primary" title="Gestionar"
                    (click)="openExecutionPhaseActions (executionPhase)">
                    <i aria-hidden="true" class="fas fa-tasks"></i>
                  </button>
                  <button *ngIf="!isExecutionPhaseClosed (executionPhase)"
                    class="btn btn-sm t-action-button btn-primary" type="button"
                    [disabled]="buttonsDisabled(contract, executionPhase) | async"
                    (click)="editExecutionDivision(contract,executionPhase)" title="{{ 'General.edit' | translate}}">
                    <i class="fas fa-pen" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm t-action-button btn-primary" type="button"
                    [disabled]="buttonDeleteDisabled(contract,executionPhase) | async"
                    (click)="deleteExecutionDivision(contract,executionPhase)"
                    title="{{ 'General.delete' | translate}}">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                  </button>
                  <button class="btn btn-sm t-action-button btn-primary" type="button"
                    (click)="showExecutionDivisionDocuments(executionPhase)" title="{{ 'Documents.list' | translate}}">
                    <i class="fas fa-file-alt" aria-hidden="true"></i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
  <ng-container *ngTemplateOutlet="newExecutionPhases; context: { contract: contract }"></ng-container>
  <ng-template #newExecutionPhases let-contract="contract">
    <div class="row">
      <div class="mt-2 col-12 pt-0 pb-2 mb-2">
        <button type="button" class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element"
          (click)="editExecutionDivision(contract)" [disabled]="buttonsDisabled(contract, executionPhase) | async"
          title="{{ 'General.add' | translate}} {{'Contracts.ExecutionPhases.name'|translate }}">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i> {{ 'General.add' | translate}}
            {{'Contracts.ExecutionPhases.name' | translate}}</span>
        </button>
      </div>
    </div>
    <div class="row">
      <!--div class="col-12">
        <p-inplace closable="closable" (onDeactivate)="newExecutionPhase(contract,newname)"><i aria-hidden="true"
            class="mr-2 fas fa-lg fa-plus"></i>
          <span pInplaceDisplay
            class="plForm-element btn btn-sm btn-outline-secondary btn-list text-left btn btn-sm t-action-button btn-primary">
            {{'+  Crear carpeta de ejecución'}}
          </span>
          <span pInplaceContent>
            <input type="text" [(ngModel)]="this.newname" pInputText
              class="plForm-element btn btn-sm btn-outline-secondary btn-list text-left btn btn-sm t-action-button btn-primary">
          </span>
        </p-inplace>
      </div-->
      <!--div class="col-6">
        <button appNoDblClick (click)="getName(contract, newname)"
          class="btn btn-sm btn-outline-secondary btn-list col-12 text-left list-element">
          <span><i aria-hidden="true" class="mr-2 fas fa-lg fa-plus"></i>Crear fase
            de ejecución</span>
        </button>
      </div-->
    </div>
  </ng-template>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE CONCICIONES ESPECIALES DE EJECUCION -->
<ng-template #contractEspecialesEjecucion let-contract="contract">
  <ng-container *ngIf="isContractEspecialesEjecucionEnabled(contract)">
    <h2 class="mt-4 mb-3 titleElement">{{'Contracts.executionConditionsMonitoring.title'|translate}} </h2>
    <div class="p-table ui-widget">
      <div class="p-table-wrapper">
        <table>
          <thead class="p-table-thead">
            <tr>
              <th style="width: 33%;">{{'Contracts.executionConditionsMonitoring.type'|translate}}</th>
              <th class="text-center">{{'Contracts.executionConditionsMonitoring.nextDueDate'|translate}}</th>
              <th class="text-center">{{'Contracts.executionConditionsMonitoring.lastReport'|translate}}</th>
              <th>{{'Contracts.executionConditionsMonitoring.compliance'|translate}}</th>
              <th style="width: 10%;"></th>
            </tr>
          </thead>
          <tbody class="p-table-tbody">
            <ng-container *ngFor="let contractLot of contract.contractLots">
              <ng-container *ngFor="let contractSpecialCond of contractLot.specialExecutionConditions">
                <tr>
                  <td>{{contractSpecialCond.idSpecialCondition.description}} / {{contractSpecialCond.detail}}</td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr *ngFor="let contractSpecialReport of getSpecialCondReports(contractSpecialCond)">
                  <td></td>
                  <td class="text-center">{{contractSpecialReport.nextDeadline | date: 'dd/MM/yyyy'}}</td>
                  <td class="text-center">{{contractSpecialReport.responseDate | date: 'dd/MM/yyyy'}}</td>
                  <td class="text-left" [ngClass]="getSpecialCondReportClass(contractSpecialReport)">
                    <span><i class="fa fas fa-lg" [ngClass]="getSpecialCondReportIcon(contractSpecialReport)"></i> {{
                      getSpecialCondReportStatus(contractSpecialReport) }}</span><span
                      *ngIf="contractSpecialReport.valorationAverage>0">
                      ({{contractSpecialReport.valorationAverage}}%)</span>
                  </td>
                  <td class="text-center">
                    <div class="btn-group">
                      <button *ngIf="contractSpecialReport.responseDoc && contractSpecialReport.responseDoc.identifier"
                        appNoDblClick aria-expanded="false" class="btn btn-sm t-action-button btn-primary"
                        title="Visualizar Informe Contratista"
                        (click)="viewDocument(contractSpecialReport.responseDoc)">
                        <i aria-hidden="true" class="fa fa-eye"></i>
                      </button>
                      <button
                        *ngIf="contractSpecialReport.valorationDoc && contractSpecialReport.valorationDoc.identifier"
                        appNoDblClick aria-expanded="false" class="btn btn-sm t-action-button btn-primary"
                        title="Visualizar Informe Valoración"
                        (click)="viewDocument(contractSpecialReport.valorationDoc)">
                        <i aria-hidden="true" class="fa fa-eye"></i>
                      </button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</ng-template>
<!-- TEMPLATE PARA LA ZONA DE INDICADORES KPIS -->
<ng-template #contractKpis let-contract="contract">
  <h2 class="mt-4 mb-3 titleElement">{{'Contracts.kpis.title'|translate}}</h2>
  <div class="p-table ui-widget">
    <div class="p-table-wrapper">
      <p-table [columns]="kpisDateList" [value]="getKpisTypeList()"
        [scrollable]="true" scrollHeight="200px">
        <!--<ng-template pTemplate="colgroup" let-columns>
          <colgroup>
            <col *ngFor="let col of columns" style="width:90px">
          </colgroup>
        </ng-template>-->
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width:300px; min-width:200px" pFrozenColumn>{{ 'Contracts.kpis.type' | translate}}</th>
            <th *ngFor="let col of columns" style="width:100px" [ngClass]="col.date? 'text-right':''">
              <span class="d-none d-sm-block"><i *ngIf="col.date" class="fa fas fa-lg fa-calendar"
                  pTooltip="{{ col.date | date:'dd/MM/yyyy'}}"></i> {{col.header}}</span>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width:300px; min-width:200px" pFrozenColumn>{{rowData.kpiDescription}}</td>
            <td *ngFor="let col of columns; let i = index"  [ngClass]="col.date?'text-center':'text-truncate'">
              <!--<span *ngIf="!col.date" pTooltip="{{rowData.kpiDescription}}">{{rowData.kpiDescription}}</span>-->
              <span *ngIf="col.date" class="pr-2">{{getKpiByTypeAndDate(rowData.kpiId,col).value}} <i
                  class="fa fas fa-lg" [ngClass]="getKpiIcon(rowData.kpiId,col)"
                  pTooltip="{{getKpiByTypeAndDate(rowData.kpiId,col).levelDescription}}"></i></span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</ng-template>
<!-- TEMPLATE PARA LA PLANIFICACION DE EXPEDIENTES DE CONTINUACION -->
<ng-template #continuationDossierPlan let-contract="contract">
  <h2 class="mt-4 mb-2">{{'Contracts.continuationDossierPlan.title'|translate}}</h2>
  <planning [id]="dossierId" [divisionId]="getSimpleIdentifierFromString(contract.division)" [continuationPlan]="true">
  </planning>
</ng-template>
<!-- TEMPLATE TAB DE CONFIGURACION DE CONTRATO -->
<ng-template #contractConfiguration let-contract="contract">
  <div class="container">
    <ng-container *ngFor="let configuration of contract?.configurations">
      <div class="row m-2">
        <div class="col-7">{{'Contracts.panel.configuration.' + configuration.attributeId |translate}}</div>
        <div class="col-5">
          <div class="p-inputgroup">
            <p-inputNumber [(ngModel)]="configuration.value"
              [disabled]="configuration.active?undefined:true"></p-inputNumber>
            <ng-container *ngIf="!configuration.active">
              <button pButton class="p-button-sm  p-button-outlined" (click)="edit (configuration)">{{'General.edit' |
                translate}}</button>
            </ng-container>
            <ng-container *ngIf="configuration.active">
              <button pButton class="p-button-sm  p-button-outlined"
                (click)="updateAttributeValue (contract, configuration, 'newValue')">{{'General.save' |
                translate}}</button>
              <button pButton class="p-button-sm p-button-outlined p-button-danger"
                (click)="cancelEdit (contract, configuration)">{{'General.cancel' | translate}}</button>
            </ng-container>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>